module.exports = __webpack_public_path__ + "img/laboratorio2_3-4_1536.05e7f6ce.jpg";